
import Vue from "vue";
import {ProfileLog} from "@/api/profile";
import * as profileAPI from "@/api/profile";

export default Vue.extend({
  name: "ChangeRoleForm",
  data() {
    return {
      roleInput: 'user' as string,
      user: {
        role: 'user'
      } as ProfileLog,
      loading: false as boolean,
      dialog: false as boolean,
    };
  },
  methods: {
    openDialog(user: ProfileLog): void {
      this.user = user;
      this.roleInput = user.role;
      this.dialog = true;
    },
    changeRole(): void {
      // this.$emit('changed', this.role)
      this.loading = true;
      profileAPI.patch(this.user.id, this.roleInput).then(resp => {
        // Update profile in list
        this.$emit('update', resp);
        this.loading = false;
        this.dialog = false;
      }).catch(err => {
        this.loading = false;
        throw err;
      })
    }
  },
  computed: {
    items: {
      set() {
        return [];
      },
      get() {
        return [
          {
            value: 'admin',
            text: this.$t("users.form.roles.admin"),
          },
          {
            value: 'maintainer',
            text: this.$t("users.form.roles.maintainer"),
          },
          {
            value: 'user',
            text: this.$t("users.form.roles.user")
          }
        ];
      },
    },
  },
  watch: {
    user: function (value) {
      this.roleInput = value.role;
    },
  }
});
